import React from "react";
import { FilterDropdown } from "./FilterDropdown";
import { SearchBar } from "./SearchBar";

export const FilteringMenu = ({
  creatorOptions,
  backgroundOptions,
  mediaTypeOptions,
  genreOptions,
  themeOptions,
  creatorsSelected,
  setCreatorsSelected,
  backgroundsSelected,
  setBackgroundsSelected,
  mediasTypesSelected,
  setMediaTypesSelected,
  genresSelected,
  setGenresSelected,
  themesSelected,
  setThemesSelected,
  searchTerm,
  setSearchTerm,
  onSearchClick,
}) => {
  return (
    <div className="filter-menu, has-ratio">
      <div className="box ml-5 mt-2">
        <button className="btn btn-info search-button" onClick={onSearchClick}>
          View Media
        </button>
      </div>
      <SearchBar
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        onSearchClick={onSearchClick}
      />
      <FilterDropdown
        label="Select Media Types"
        options={mediaTypeOptions}
        values={mediasTypesSelected}
        setValue={setMediaTypesSelected}
      />
      <FilterDropdown
        label="Select APIDA Identities"
        options={backgroundOptions}
        values={backgroundsSelected}
        setValue={setBackgroundsSelected}
      />
      <FilterDropdown
        label="Select Creators"
        options={creatorOptions}
        values={creatorsSelected}
        setValue={setCreatorsSelected}
      />
      <FilterDropdown
        label="Select Genres"
        options={genreOptions}
        values={genresSelected}
        setValue={setGenresSelected}
      />
      <FilterDropdown
        label="Select Themes"
        options={themeOptions}
        values={themesSelected}
        setValue={setThemesSelected}
      />
    </div>
  );
};
